import update from 'immutability-helper';
import { EContentBlockType } from '../types/product.types';

export const move = (array, from, to) => {
  const item = array[from];

  return update(array, {
    $splice: [
      [from, 1],
      [to, 0, item],
    ],
  });
};

export const isActiveMenuEnabled = (activeMenuId, contentBlocks) => {
  const matchingContentBlock = contentBlocks.find(
    contentBlock => contentBlock['contentType'] === activeMenuId
  );
  const enabled = matchingContentBlock?.enabled;

  return activeMenuId ? enabled : undefined;
};

export const BACKEND_TO_FRONTEND_BLOCK_TYPE_MAP = {
  General: EContentBlockType.GENERAL,
  PRODUCT_JOURNEY_BLOCK: EContentBlockType.PRODUCT_JOURNEY,
  ABOUT_BLOCK: EContentBlockType.ABOUT,
  MORE_INFO_BLOCK: EContentBlockType.MORE_INFO,
  IMPACT_FACTS_BLOCK: EContentBlockType.IMPACT_FACTS,
  FEEDBACK_BLOCK: EContentBlockType.FEEDBACK,
  PRODUCTS_BLOCK: EContentBlockType.MORE_PRODUCTS,
  VERIFIED_PAYMENT_BLOCK: EContentBlockType.VERIFIED_PAYMENTS,
};

export const FRONTEND_TO_BACKEND_BLOCK_TYPE_MAP = {
  [EContentBlockType.GENERAL]: 'General',
  [EContentBlockType.PRODUCT_JOURNEY]: 'PRODUCT_JOURNEY_BLOCK',
  [EContentBlockType.ABOUT]: 'ABOUT_BLOCK',
  [EContentBlockType.MORE_INFO]: 'MORE_INFO_BLOCK',
  [EContentBlockType.IMPACT_FACTS]: 'IMPACT_FACTS_BLOCK',
  [EContentBlockType.FEEDBACK]: 'FEEDBACK_BLOCK',
  [EContentBlockType.MORE_PRODUCTS]: 'PRODUCTS_BLOCK',
  [EContentBlockType.VERIFIED_PAYMENTS]: 'VERIFIED_PAYMENT_BLOCK',
};
